import { Button } from "antd";
import React, { useState } from "react";
import ModalAddCustomer from "../modal/ModalAddCustomer";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonAddCustomerProps {
  // Add props here
}

const ButtonAddCustomer: React.FC<ButtonAddCustomerProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
    useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button
        onClick={showModal}
     
        className="font-medium"
        type="primary"
        size="large"
    
      >
        Thêm khách hàng
      </Button>
      <ModalAddCustomer onClose={handleCancel} visible={isModalOpen} />
    </div>
  );
};

export default ButtonAddCustomer;
